import api from "@/api/api-v2-config";

export async function postAdminAxios(payload) {
    return await api.post("ecoms/registeradmin", payload);
  }

export async function getUserListAxios() {    
    return await api.get("ecoms/users?pageNumber=1&pageSize=10000");
}

export async function getOrderListAxios() {    
  return await api.get("ecoms/orders?pageNumber=1&pageSize=10000");
}

// export async function postCompleteOrderAxios(orderId) {
//   return await api.post("ecoms/completeorder?orderId="+ orderId);
// }

export async function postCompleteOrderAxios(orderId, status) {
  return await api.post(
    `ecoms/updateorder?orderId=${orderId}&status=${status}`
  );
}